export const GET_API_KEYS = 'GET_API_KEYS';
export const GET_API_KEYS_SUCCESS = 'GET_API_KEYS_SUCCESS';
export const GET_API_KEYS_ERROR = 'GET_API_KEYS_ERROR';
export const ADD_API_KEY = 'ADD_API_KEY';
export const ADD_API_KEY_SUCCESS = 'ADD_API_KEY_SUCCESS';
export const ADD_API_KEY_ERROR = 'ADD_API_KEY_ERROR';
export const DELETE_API_KEY = 'DELETE_API_KEY';
export const DELETE_API_KEY_SUCCESS = 'DELETE_API_KEY_SUCCESS';
export const DELETE_API_KEY_ERROR = 'DELETE_API_KEY_ERROR';

export const getApiKeys = () => ({
  type: GET_API_KEYS,
});

export const addApiKey = (name) => ({
  type: ADD_API_KEY,
  payload: { name },
});

export const deleteApiKey = (apiKey) => ({
  type: DELETE_API_KEY,
  payload: apiKey,
});
